"use client";
import React, { useEffect } from "react";
import { Card } from "antd";
import { cn } from "../../utils/cn";
import { FiFilter, FiPlus } from "react-icons/fi";
import { Dropdown, Button } from "antd";
import ListGridButtons from "./listGridViewButtons";
import CommonInput from "./input";
import { SearchOutlined } from "@ant-design/icons";
import CommonSelect from "./select";

const ExtraCmp = ({
  isAdvanceSearch,
  isSearch,
  isFilters,
  isListGridView,
  isCreateButton,
}) => {
  return (
    <div className="flex items-center gap-x-2">
      {isAdvanceSearch?.show && (
        <Dropdown
          popupRender={() => (
            <div className="px-3  min-w-[300px] -mr-5 !bg-transparent">
              {isAdvanceSearch.children}
            </div>
          )}
          trigger={["click"]}
          placement="bottomRight"
          className="!bg-transparent"
        >
          <Button
            className={cn(
              "flex items-center gap-x-1 !bg-primary text-primary hover:!text-white hover:!bg-primary/80 !border hover:!border-primary",
              isCreateButton.show &&
              "!bg-transparent !border !border-primary !text-primary hover:!bg-primary hover:!text-white transition-colors duration-150 ease-in-out"
            )}

            size="large"
            style={{ borderColor: "#2dbdf2" }}
          >
            <span>
              {" "}
              <FiFilter size={16} />
            </span>
            Advance Search
          </Button>
        </Dropdown>
      )}


      {isCreateButton.show && (
        <Button
          className="flex items-center gap-x-1 !bg-primary text-white hover:!bg-primary/80 hover:!border-primary "
          size="large"
          onClick={isCreateButton.onclick}
        >
          <span>
            <FiPlus size={16} />
          </span>
          {isCreateButton.text}
        </Button>
      )}
      {isListGridView.show && (
        <ListGridButtons
          viewType={isListGridView.viewType}
          setViewType={isListGridView.setViewType}
          viewFor={isListGridView.viewFor}
        />
      )}
    </div>
  );
};

const CommonCard = ({
  title,
  titleClassName,
  extra,
  children,
  style,
  className,
  cardHeaderClassName,
  isAdvanceSearch = {
    show: false,
    children: null,
  },
  isSearch = {
    show: false,
    searchInput: "",
    placeholder: "",
    setSearchInput: () => { },
  },
  isFilters = {
    show: false,
    data: null,
  },
  isListGridView = {
    show: false,
    viewType: "",
    setViewType: () => { },
    viewFor: "",
  },
  isLoading = {
    show: false,
    loaderCmp: null,
  },
  isCreateButton = {
    show: false,
    text: "",
    onclick: () => { },
  },
  isExtraButton = {
    show: false,
    title: "",
    className: "",
    onClick: () => { },
    icon: null,
    disabled: false,
    data: [] // New data array for multiple buttons
  },
}) => {


  const shouldHideTitle =
    !title &&
    !isSearch?.show &&
    !isExtraButton?.show &&
    !isAdvanceSearch?.isClearButton?.show &&
    !isFilters?.show;


  const shouldHideExtra =
    !isAdvanceSearch?.show &&
    !isSearch?.show &&
    !isFilters?.show &&
    !isListGridView?.show &&
    !isCreateButton?.show;


  return (
    <Card
      {...(!shouldHideTitle && {
        title: (
          <div className={cn(cardHeaderClassName, isFilters.show || isExtraButton?.show ? "mr-2" : "")}>
            {isSearch?.show && (
              <CommonInput
                placeholder={isSearch.placeholder || ""}
                icon={<SearchOutlined />}
                value={isSearch.searchInput}
                onChange={(e) => isSearch.setSearchInput(e.target.value)}
                className="w-72"
              />
            )}

            <div className="flex items-center justify-between gap-x-2 ">
              <span className={cn("text-2xl font-semibold", titleClassName)}>{title}</span>

              {(isFilters?.show || isExtraButton?.show) && <div className="flex justify-end items-center gap-x-2">
                {isFilters?.show && (
                  <>
                    {
                      isFilters?.data?.map((filter) => (
                        <CommonSelect
                          key={filter.name}
                          placeholder={filter.placeholder}
                          options={filter.options}
                          onChange={filter.onChange}
                          className={filter.className}
                        />
                      ))
                    }
                  </>
                )}
                {isExtraButton?.show && (
                  <>
                    {isExtraButton?.data && isExtraButton.data.length > 0 ? (
                      isExtraButton.data.map((btn, index) => (
                        <Button
                          key={index}
                          type="link"
                          disabled={btn?.disabled}
                          onClick={btn.onClick}
                          className={cn(btn?.className, btn?.icon && "flex items-center gap-x-1")}
                        >
                          {btn?.icon && <span>{btn?.icon}</span>}
                          {btn?.title || ""}
                        </Button>
                      ))
                    ) : (
                      <Button
                        type="link"
                        disabled={isExtraButton?.disabled}
                        onClick={isExtraButton.onClick}
                        className={cn(isExtraButton?.className, isExtraButton?.icon && "flex items-center gap-x-1")}
                      >
                        {isExtraButton?.icon && <span>{isExtraButton?.icon}</span>}
                        {isExtraButton?.title || ""}
                      </Button>
                    )}
                  </>
                )}
              </div>}


              {isAdvanceSearch?.isClearButton?.show && (
                <Button
                  type="link"
                  onClick={isAdvanceSearch?.isClearButton?.onClick}
                >
                  {isAdvanceSearch?.isClearButton?.title}
                </Button>
              )}
            </div>
          </div>
        ),
      })}

      {...(!shouldHideExtra && {
        extra: (
          <ExtraCmp
            isAdvanceSearch={isAdvanceSearch}
            isSearch={isSearch}
            isFilters={isFilters}
            isListGridView={isListGridView}
            isCreateButton={isCreateButton}
          />
        ),
      })}

      className={cn("", className)}
      style={style}
    >
      <div>{isLoading.show ? isLoading.loaderCmp : children}</div>
    </Card>

  );
};

export default CommonCard;
